import { defineStore } from "pinia";

import * as R from "ramda";
import axios from "../../axios-auth";

export const useEditorFilesStore = defineStore("editorfiles", {
  state: () => ({
    editorFiles: {}
  }),

  getters: {
    getEditorFiles(state) {
      return R.pathOr([], ["editorFiles"], state);
    },
    findEditorFiles(state) {
      return function (uuid) {
        return R.pathOr(null, ["editorFiles", uuid], state);
      };
    }
  },

  actions: {
    addEditorFile(item) {
      this.editorFiles = {
        ...this.editorFiles,
        [item.uuid]: item
      };
    }
  }
});
